import React from 'react';
import { FadeIn } from './Shared';
import { Quote } from 'lucide-react';
interface TestimonialProps {
  quote: string;
  author: string;
  location: string;
}
const TestimonialCard = ({
  quote,
  author,
  location
}: TestimonialProps) => <div className="bg-navy-900/40 p-6 md:p-8 rounded-2xl border border-white/10 relative h-full flex flex-col" data-id="element-333">
    <Quote className="absolute top-6 right-6 w-8 h-8 text-premium-gold/10" data-id="element-334" />
    <div className="text-premium-gold-luminous mb-5 text-xs flex gap-1" data-id="element-335">
      {[...Array(5)].map((_, i) => <span key={i} data-id="element-336">⭐</span>)}
    </div>
    <p className="text-base md:text-lg text-gray-100 font-sans mb-6 relative z-10 flex-grow leading-relaxed opacity-95" data-id="element-337">
      "{quote}"
    </p>
    <div className="border-t border-white/5 pt-5 mt-auto" data-id="element-338">
      <div className="font-bold text-white tracking-wide text-sm mb-0.5 font-sans" data-id="element-339">
        {author}
      </div>
      <div className="text-[11px] text-premium-gold-light/70 font-bold uppercase tracking-wider font-sans" data-id="element-340">
        {location}
      </div>
    </div>
  </div>;
export const Testimonials = () => {
  return <section className="py-16 md:py-24 px-4 bg-navy-950 relative overflow-hidden" data-id="element-341">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(212,175,55,0.03),transparent_70%)] pointer-events-none" data-id="element-342"></div>
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-343">
        <FadeIn data-id="element-344">
          <div className="grid md:grid-cols-3 gap-6" data-id="element-345">
            <TestimonialCard quote="La primera semana bajó la intensidad de los berrinches a la mitad. El Protocolo de los 90 Segundos funciona de verdad." author="Mariana G." location="Córdoba" data-id="element-346" />
            <TestimonialCard quote="Por fin entendí por qué mi hijo explotaba siempre a las 5 de la tarde. El Tomo 3 me lo explicó todo." author="Laura P." location="Rosario · Mamá de mellizos" data-id="element-347" />
            <TestimonialCard quote="Pensé que era el problema yo. El Tomo 1 me cambió la cabeza. Ahora reacciono diferente." author="Roberto M." location="Buenos Aires" data-id="element-348" />
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const MoreTestimonials = () => {
  return <section className="py-16 md:py-24 px-4 bg-navy-900/50 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-349">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-350">
        <FadeIn data-id="element-351">
          <div className="flex flex-col items-center mb-16" data-id="element-352">
            <div className="bg-red-500/10 text-red-400 px-6 py-2 rounded-full border border-red-500/20 text-xs font-bold tracking-[0.2em] mb-6 uppercase font-sans" data-id="element-353">
              HISTORIAS REALES
            </div>
            <h2 className="text-3xl md:text-5xl text-center text-white leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-354">
              ❤️ MÁS FAMILIAS QUE YA LO TIENEN
            </h2>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-355">
            <TestimonialCard quote="El Protocolo P.A.U.S.A. me cambió la vida. Antes del MegaPack cada berrinche terminaba con los dos llorando. Ahora tengo un sistema y se nota." author="Cecilia R." location="Mendoza | MegaPack + Método Raíces" data-id="element-356" />
            <TestimonialCard quote="Los berrinches en el supermercado eran mi pesadilla. Después del Bono 3 no volví a ceder un límite por vergüenza. Fue un cambio inmediato." author="Roberto M." location="Buenos Aires | MegaPack Calma Total" data-id="element-357" />
            <TestimonialCard quote="El Método Raíces me hizo entender que estaba elogiando mal a mi hijo. Cambié una sola cosa y en dos semanas su reacción ante los errores fue completamente diferente." author="Sofía C." location="La Plata | MegaPack + Método Raíces" data-id="element-358" />
            <TestimonialCard quote="El Tomo 5 de Reparación me hizo llorar. No sabía que reparar bien podía fortalecer el vínculo más que no fallar nunca. Ese capítulo solo vale todo el precio." author="Pablo A." location="Neuquén | MegaPack Calma Total" data-id="element-359" />
            <TestimonialCard quote="Mi hijo de 4 años empezó a decir 'estoy enojado' en lugar de tirar cosas. En tres semanas. Eso no tiene precio." author="Daniela M." location="Rosario | MegaPack Calma Total" data-id="element-360" />
          </div>
        </FadeIn>
      </div>
    </section>;
};